module.exports = __webpack_public_path__ + "static/img/13-北京钱学森中学1.822a8c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/13-北京钱学森中学1.png
// module id = pdgm
// module chunks = 0